<article class="course-description">
    @if (showTitle()) {
        <h2 class="course-description__title">{{ title() }}</h2>
    }
    <p class="course-description__text">
      {{ description() }}
    </p>
  </article>